import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { TFunction } from 'i18next'
import { logger } from '@/services/Logger'
import { AppSettingsPageMenuType, useAppContext } from '@/AppContext'
import { DialogTitle } from '@/components/Dialog'
import { VerticalTabs } from '@/components/VerticalTabs'
import { AboutSection } from './internal/AboutSection'
import { AccountSection } from './internal/AccountSection'
import DeveloperSettings from '../SessionSettings/internal/developer/DeveloperSettings'

export function AppSettings({ startingPage = 'about' }: { startingPage?: AppSettingsPageMenuType }) {
    const { t } = useTranslation()
    const [appState] = useAppContext()

    const [currMenuSelection, setCurrMenuSelection] = useState<AppSettingsPageMenuType>(startingPage)

    useEffect(() => {
        logger.event({ page: 'app-settings', action: 'enter' })
        return () => {
            logger.event({ page: 'app-settings', action: 'exit' })
        }
    }, [])

    return (
        <div className="h-full flex flex-col gap-[10px] md:gap-[35px]">
            <DialogTitle className="pl-6 pb-0">{t('Settings')}</DialogTitle>

            <VerticalTabs
                tabs={getTabs(t, appState.appState.isInDevMode)}
                onTabChange={(tab) => setCurrMenuSelection(tab as AppSettingsPageMenuType)}
                currentTab={currMenuSelection}
            >
                <>
                    {currMenuSelection === 'about' && <TabContainer>{<AboutSection />}</TabContainer>}
                    {currMenuSelection === 'account' && <TabContainer>{<AccountSection />}</TabContainer>}
                    {currMenuSelection === 'dev' && <DeveloperSettings />}
                </>
            </VerticalTabs>
        </div>
    )
}

function TabContainer(props: { children?: React.ReactNode }) {
    return <div className="flex flex-col gap-[10px]">{props.children}</div>
}

function getTabs(t: TFunction<'translation'>, devMode: boolean) {
    let tabs = [
        { id: 'account', label: t('Account') },
        { id: 'about', label: t('About') },
    ]

    if (devMode) {
        tabs.push({ id: 'dev', label: t('Developer') })
    }
    return tabs
}
